import { Input } from '@eika-infrastruktur/ui-input';
import React, { ChangeEvent, useState, useEffect, useCallback } from 'react';

interface SuffixedInputProps {
    label: string;
    value: number;
    suffix: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    valueFormatter?: (value: number) => string;
}

const SuffixedInput = (props: SuffixedInputProps) => {
    const formatValue = useCallback(
        (value: number) => {
            if (props.valueFormatter) {
                return props.valueFormatter(value);
            }
            return value.toString();
        },
        [props]
    );
    const addSuffix = useCallback(
        (value: number) => {
            return value ? formatValue(value).concat(` ${props.suffix}`) : `0 ${props.suffix}`;
        },
        [formatValue, props.suffix]
    );

    const [formattedValue, setFormattedValue] = useState(addSuffix(props.value));
    const [hasFocus, setFocus] = useState(false);

    const onBlur = () => {
        setFocus(false);
        setFormattedValue(addSuffix(props.value));
    };

    const onFocus = () => {
        setFocus(true);
        setFormattedValue(`${props.value}`);
    };

    useEffect(() => {
        if (hasFocus) {
            setFormattedValue(`${props.value}`);
        } else {
            setFormattedValue(addSuffix(props.value));
        }
    }, [props.value, hasFocus, addSuffix]);

    return (
        <Input
            label={props.label}
            type="tel"
            value={formattedValue}
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={props.onChange}
            style={props.style}
        />
    );
};

export default SuffixedInput;
